import React from 'react';
import MuiRadioGroup, { RadioGroupProps } from '@mui/material/RadioGroup';
import { radioGroupSx } from './RadioGroup.styles';
import { SxProps, Theme } from '@mui/material/styles';

export const RadioGroup = React.forwardRef<HTMLDivElement, RadioGroupProps>((props, ref) => {
  return <MuiRadioGroup ref={ref} {...props} sx={[radioGroupSx, props.sx] as SxProps<Theme>} />;
});

RadioGroup.displayName = 'RadioGroup';